import { Modal } from './Modal'

export interface ShortcutsHelpModalProps {
  open: boolean
  onClose: () => void
}

const SHORTCUTS: { key: string; label: string }[] = [
  { key: 'N', label: 'Novo lançamento' },
  { key: 'R', label: 'Recalcular tudo' },
  { key: 'E', label: 'Exportar' },
  { key: 'I', label: 'Importar' },
  { key: ',', label: 'Configurações' },
  { key: '?', label: 'Esta ajuda' },
  { key: 'Esc', label: 'Fechar diálogo aberto' },
]

export function ShortcutsHelpModal({ open, onClose }: ShortcutsHelpModalProps) {
  return (
    <Modal open={open} title="Atalhos de teclado" onClose={onClose} width="narrow">
      <ul className="divide-rule divide-y">
        {SHORTCUTS.map((s) => (
          <li key={s.key} className="flex items-center justify-between py-2 text-sm">
            <span>{s.label}</span>
            <kbd className="border-ink font-mono border px-2 py-0.5 text-[11px]">
              {s.key}
            </kbd>
          </li>
        ))}
      </ul>
      <p className="text-muted mt-4 text-[11px]">
        Atalhos ignoram inputs (você pode digitar normalmente).
      </p>
    </Modal>
  )
}
